/**
 * Include your custom JavaScript here.
 *
 * Cut-to-order DPO pricing is handled by ITORIS DPO Global Extra JavaScript only.
 * Do not patch PriceFormula or dpo_before_initialize here — it conflicts with ITORIS.
 * deploy: 20260601-gn-hide-vendor
 */

(function hideVendorBranding() {
  var blocked = /justfornets|just for nets|\bjfn\b/i;
  function scrub(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product-meta__vendor, .product-item__vendor, .vendor, [data-product-vendor]').forEach(function (el) {
      el.style.display = 'none';
    });
    root.querySelectorAll('a, span, p, li, div').forEach(function (el) {
      if (el.children.length === 0 && blocked.test(el.textContent || '')) {
        el.style.display = 'none';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { scrub(document); });
})();
